export const a2Notes = [
  {
    "id": "a2_1_weil_perfekt_von",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.1 — Weil ; Perfekt (Foljet e Ndashme/Pandashme) ; von + Dativ",
    "description": "Lidhëza weil me foljen në fund, perfekt me folje të ndashme dhe të pandashme, foljet me -ieren dhe përdorimi i von + Dativ.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Konjunktion \"weil\" (sepse) — Rregulla e renditjes</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Kur përdorim lidhëzën <b>weil</b>, folja në pozicionin e dytë zhvendoset <b>çdo herë në fund të fjalisë</b> (Verb ans Ende).\n              </p>\n            </div>\n\n            <ul class=\"list-disc pl-5 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Ich lerne Deutsch, <b>weil</b> ich die deutsche Sprache <b>liebe</b>.</i> (Unë mësoj gjermanisht, sepse unë e dua gjuhën gjermane)</li>\n              <li><i>Ich bin traurig, <b>weil</b> ich hier keine Menschen <b>kenne</b>.</i> (Unë jam i/e mërzitur, sepse këtu nuk njoh asnjë njeri)</li>\n              <li><i>Ich bin eine gute Studentin, <b>weil</b> ich immer die Hausaufgaben <b>mache</b>.</i> (Unë jam një studente e mirë, sepse unë i bëj çdo herë detyrat)</li>\n              <li><i>Ich bin eine gute Studentin, <b>weil</b> ich immer die Hausaufgaben <b>gemacht habe</b>.</i> (Në Perfekt: folja ndihmëse <b>habe</b> shkon krejt në fund!)</li>\n              <li><i>Warum bist du gestern nicht gekommen? — <b>Weil</b> mein Hund krank <b>war</b>.</i> (Sepse qeni im ishte i sëmurë)</li>\n              <li><i>Warum wohnst du so weit draußen? — <b>Weil</b> die Mieten im Zentrum so teuer <b>sind</b>.</i> (Sepse në qendër qiratë janë shumë të shtrenjta)</li>\n            </ul>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-6\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Perfekt: Trennbare Verben (Foljet e ndashme)</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Formula: <b>Präfix + ge...t</b> ose <b>Präfix + ge...en</b> (pjesëza -ge- vendoset në mes të parashtesës dhe rrënjës së foljes).\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n              <li><b>kennenlernen</b> &rarr; <i>kennengelernt</i> (njoftohem): <i>Wir lernen uns kennen &rarr; Wir haben uns kennengelernt.</i></li>\n              <li><b>einkaufen</b> &rarr; <i>eingekauft</i> (bëj blerje): <i>Du kaufst ein &rarr; Du hast eingekauft.</i></li>\n              <li><b>anrufen</b> &rarr; <i>angerufen</i> (marr në telefon): <i>Ich rufe Lara an &rarr; Ich habe Lara angerufen.</i></li>\n              <li><b>ankommen</b> &rarr; <i>angekommen</i> (mbërrij / arrij)</li>\n            </ul>\n\n            <div class=\"rounded-xl border-l-4 border-red-500 bg-red-50/60 p-4 dark:bg-red-950/20 mt-6\">\n              <h4 class=\"font-bold text-red-900 dark:text-red-200\">3. Perfekt: Nicht-trennbare Verben & Verben auf -ieren</h4>\n              <p class=\"text-sm text-red-800 dark:text-red-300\">\n                Foljet e pandashme (me be-, er-, ver-, ent-, emp-, ge-, miss-, zer-) dhe foljet me <b>-ieren</b> marrin mbaresën <b>-t / -en</b> dhe <b>NUK marrin -ge- fare!</b>\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n              <li><b>erleben</b> &rarr; <i>erlebt</i> (përjetoj): <i>Ich habe erlebt.</i> (pa -ge-)</li>\n              <li><b>verstehen</b> &rarr; <i>verstanden</i> (kuptoj): <i>Ich habe es verstanden.</i></li>\n              <li><b>bemerken</b> &rarr; <i>bemerkt</i> (vë re): <i>Ich habe es bemerkt.</i></li>\n              <li><b>passieren</b> &rarr; <i>ist passiert</i>: <i>Hier sind immer komische Dinge passiert.</i></li>\n              <li><b>telefonieren</b> &rarr; <i>hat telefoniert</i>: <i>Ich habe gestern mit Lara telefoniert.</i></li>\n            </ul>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-6\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">4. Namen im Genitiv: von + Dativ</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Kur zëvendësojmë gjinoren në të folurën e përditshme: <b>von + Dativ</b>.\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Annas Mutter</i> = <b>die Mutter von Anna</b></li>\n              <li><i>Ihre Tasche</i> = <b>die Tasche von ihr</b></li>\n              <li><i>Sein Bruder</i> = <b>der Bruder von ihm</b></li>\n            </ul>\n          </section>\n        ",
    "tables": [
      {
        "label": "Përemrat vetorë: Nominativ, Akkusativ, Dativ",
        "headers": [
          "Nominativ (Kush?)",
          "Akkusativ (Kë? / Çka?)",
          "Dativ (Kujt?)"
        ],
        "rows": [
          [
            "Ich",
            "Mich",
            "Mir"
          ],
          [
            "Du",
            "Dich",
            "Dir"
          ],
          [
            "Er / Sie / Es",
            "Ihn / Sie / Es",
            "Ihm / Ihr / Ihm"
          ],
          [
            "Wir",
            "Uns",
            "Uns"
          ],
          [
            "Ihr",
            "Euch",
            "Euch"
          ],
          [
            "Sie / sie",
            "Sie / sie",
            "Ihnen / ihnen"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Ich lerne Deutsch, weil ich die deutsche Sprache liebe.",
        "alb": "Unë mësoj gjermanisht, sepse unë e dua gjuhën gjermane."
      },
      {
        "ger": "Wir haben uns gestern im Park kennengelernt.",
        "alb": "Ne jemi njoftuar dje në park."
      },
      {
        "ger": "Hier sind immer komische Dinge passiert.",
        "alb": "Këtu gjithmonë kanë ndodhur gjëra të çuditshme."
      },
      {
        "ger": "Das ist die Tasche von ihr.",
        "alb": "Kjo është çanta e saj."
      }
    ],
    "exercises": [
      {
        "question": "Ku renditet folja në fjalinë me 'weil'? (Ich lerne Deutsch, weil ich die Sprache ...)",
        "options": [
          "Në pozicionin e dytë",
          "Krejt në fund të fjalisë",
          "Në fillim para kryefjalës"
        ],
        "correct": 1,
        "explanation": "Lidhëza 'weil' krijon fjali të nënrenditur (Nebensatz), ku folja e zgjedhuar shkon gjithmonë në fund."
      },
      {
        "question": "Cila është forma e saktë në Perfekt e foljes 'telefonieren'?",
        "options": [
          "getelefoniert",
          "telefoniert",
          "getelefonen"
        ],
        "correct": 1,
        "explanation": "Foljet që mbarojnë me '-ieren' nuk marrin parashtesën '-ge-' në Perfekt (marrin vetëm prapashtesën '-t')."
      }
    ]
  },
  {
    "id": "a2_2_wechselpraepositionen_verben",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.2 — Wechselpräpositionen ; Çiftet e foljeve ; Direktionaladverbien",
    "description": "Parafjalët me dy rasa (Wohin? Akkusativ vs. Wo? Dativ), çiftet e foljeve stellen/stehen, legen/liegen dhe ndajfoljet dort/dorthin, rein, raus, runter.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Deklinimi i nyjeve në Akkusativ dhe Dativ</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                <b>Nominativ</b> i përgjigjet pyetjes <b>WER</b> (Kush?) &bull; \n                <b>Akkusativ</b> i përgjigjet pyetjes <b>WEN</b> (Kë?) &bull; \n                <b>Dativ</b> i përgjigjet pyetjes <b>WEM</b> (Kujt?).\n              </p>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Wechselpräpositionen (Parafjalët me dy rasa)</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Parafjalët: <b>an, auf, hinter, in, neben, über, unter, vor, zwischen</b>.<br/>\n                &bull; <b>Wohin? (Ku / Për ku? - Drejtim / Lëvizje) &rarr; AKKUSATIV</b><br/>\n                &bull; <b>Wo? (Ku? - Pozicion statik / Vendndodhje) &rarr; DATIV</b>\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Wohin lege ich die Sachen? &rarr; Ich lege die Sachen <b>auf den Tisch</b> (Akkusativ).</i></li>\n              <li><i>Wo liegen die Sachen? &rarr; Die Sachen liegen <b>auf dem Tisch</b> (Dativ).</i></li>\n              <li><i>Ich stelle die Milch <b>in den Kühlschrank</b> (Wohin? &rarr; Akkusativ).</i></li>\n              <li><i>Die Milch steht <b>im (in dem) Kühlschrank</b> (Wo? &rarr; Dativ).</i></li>\n            </ul>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Direktionaladverbien (Ndajfoljet e drejtimit)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                <b>Wo? (Dativ)</b>: dort (atje), da (aty), hier (këtu).<br/>\n                <b>Wohin? (Akkusativ)</b>: dorthin, dahin, hierhin.<br/>\n                Parafjalët e drejtimit me r-: <b>rein</b> (brenda), <b>raus</b> (jashtë), <b>rauf</b> (mbi), <b>runter</b> (poshtë), <b>rüber</b> (kalon/ndërron pozitën).<br/>\n                Formimi ndajfolje + folje: <i>runterfallen</i> (bie poshtë) &rarr; gjithmonë folje të ndashme! P.sh: <i>Fallen Sie nicht runter!</i> (Mos bini poshtë!)\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Deklinimi i nyjeve në 3 rasat",
        "headers": [
          "Gjinia",
          "Nominativ (Wer?)",
          "Akkusativ (Wen?)",
          "Dativ (Wem?)"
        ],
        "rows": [
          [
            "Mashkullore (Maskulin)",
            "der / ein",
            "den / einen",
            "dem / einem"
          ],
          [
            "Femërore (Feminin)",
            "die / eine",
            "die / eine",
            "der / einer"
          ],
          [
            "Asnjëanëse (Neutral)",
            "das / ein",
            "das / ein",
            "dem / einem"
          ],
          [
            "Shumës (Plural)",
            "die / -",
            "die / -",
            "den + n / -"
          ]
        ]
      },
      {
        "label": "Çiftet e foljeve: Akkusativ (Lëvizje) vs. Dativ (Qetësi)",
        "headers": [
          "Akkusativ (Wohin? - Veprim)",
          "Dativ (Wo? - Gjendje)",
          "Kuptimi në shqip"
        ],
        "rows": [
          [
            "legen (vë shtrirë)",
            "liegen (ndodhet shtrirë)",
            "vendos shtrirë / rri shtrirë"
          ],
          [
            "stellen (vë në këmbë)",
            "stehen (ndodhet në këmbë)",
            "vendos vertikalisht / qëndron vertikalisht"
          ],
          [
            "setzen (ul)",
            "sitzen (rri ulur)",
            "ul dikë / rri ulur"
          ],
          [
            "hängen (var diku)",
            "hängen (varet diku)",
            "var / është varur"
          ],
          [
            "stecken (fut brenda)",
            "stecken (gjendet brenda)",
            "fut / ndodhet i futur"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Ich stelle das Glas auf den Tisch.",
        "alb": "Unë e vendos gotën mbi tavolinë. (Wohin? -> Akkusativ)"
      },
      {
        "ger": "Das Glas steht auf dem Tisch.",
        "alb": "Gota qëndron mbi tavolinë. (Wo? -> Dativ)"
      },
      {
        "ger": "Wohin gehst du? — Ich gehe dorthin.",
        "alb": "Për ku po shkon? — Po shkoj atje."
      },
      {
        "ger": "Fallen Sie nicht runter!",
        "alb": "Mos bini poshtë!"
      }
    ],
    "exercises": [
      {
        "question": "Plotëso fjalinë: Ich lege das Buch auf ... Tisch (der Tisch).",
        "options": [
          "den",
          "dem",
          "der"
        ],
        "correct": 0,
        "explanation": "Folja 'legen' tregon lëvizje (Wohin?), prandaj kërkon Akkusativ: 'auf den Tisch'."
      },
      {
        "question": "Plotëso fjalinë: Das Buch liegt auf ... Tisch.",
        "options": [
          "den",
          "dem",
          "das"
        ],
        "correct": 1,
        "explanation": "Folja 'liegen' tregon pozicion statik (Wo?), prandaj kërkon Dativ: 'auf dem Tisch'."
      }
    ]
  },
  {
    "id": "a2_3_indefinitpronomen",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.3 — Indefinitpronomen (Përemrat e Pacaktuar)",
    "description": "Përemrat e pacaktuar einer, eine, eins, welche dhe mohimi me keiner, keine, keins, keine në Nominativ dhe Akkusativ.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">Çfarë janë Indefinitpronomen?</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Përemrat e pacaktuar përdoren <b>në vend të emrave</b> për të treguar frymorë, dukuri ose sende në mënyrë të pacaktuar, pa e përsëritur emrin.\n              </p>\n            </div>\n\n            <div class=\"grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm\">\n              <div class=\"rounded-lg border border-zinc-200 p-3 bg-white dark:bg-zinc-900 dark:border-zinc-800\">\n                <p class=\"font-bold text-zinc-900 dark:text-white\">Pohore (Pozitiv):</p>\n                <ul class=\"mt-2 space-y-1 text-zinc-600 dark:text-zinc-400\">\n                  <li>&bull; Das ist ein Bleistift &rarr; <b>Das ist einer.</b> (Ky është njëri.)</li>\n                  <li>&bull; Das ist eine Tasche &rarr; <b>Das ist eine.</b> (Kjo është njëra.)</li>\n                  <li>&bull; Das ist ein Auto &rarr; <b>Das ist eins.</b> (Kjo është njëra.)</li>\n                  <li>&bull; Das sind Bücher &rarr; <b>Das sind welche.</b> (Këto janë disa.)</li>\n                </ul>\n              </div>\n\n              <div class=\"rounded-lg border border-zinc-200 p-3 bg-white dark:bg-zinc-900 dark:border-zinc-800\">\n                <p class=\"font-bold text-zinc-900 dark:text-white\">Mohore (Negativ):</p>\n                <ul class=\"mt-2 space-y-1 text-zinc-600 dark:text-zinc-400\">\n                  <li>&bull; Hier ist kein Bleistift &rarr; <b>Hier ist keiner.</b></li>\n                  <li>&bull; Hier ist keine Tasche &rarr; <b>Hier ist keine.</b></li>\n                  <li>&bull; Hier ist kein Auto &rarr; <b>Hier ist keins.</b></li>\n                  <li>&bull; Hier sind keine Bücher &rarr; <b>Hier sind keine.</b></li>\n                </ul>\n              </div>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">Përemrat pronorë si përemra të pacaktuar</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Kur emri mungon, përemri pronor merr mbaresën e nyjes së shquar:\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-blue-900 dark:text-blue-200\">\n                <li>&bull; Das ist mein Bleistift &rarr; <b>Das ist meiner.</b></li>\n                <li>&bull; Das ist deine Tasche &rarr; <b>Das ist deine.</b></li>\n                <li>&bull; Das ist sein Auto &rarr; <b>Das ist seins.</b></li>\n                <li>&bull; Das sind ihre Bücher &rarr; <b>Das sind ihre.</b></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">Indefinitpronomen në Akkusativ</h4>\n              <ul class=\"text-sm space-y-1 text-emerald-900 dark:text-emerald-200\">\n                <li>&bull; Ich möchte einen Bleistift &rarr; <b>Ich möchte einen.</b></li>\n                <li>&bull; Ich nehme eine Tasche &rarr; <b>Ich nehme eine.</b></li>\n                <li>&bull; Ich brauche ein Auto &rarr; <b>Ich brauche eins.</b></li>\n                <li>&bull; Ich möchte Bücher &rarr; <b>Ich möchte welche.</b></li>\n              </ul>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Pasqyra e Indefinitpronomen sipas gjinisë dhe rasës",
        "headers": [
          "Rasa",
          "Mashkullore (der)",
          "Femërore (die)",
          "Asnjëanëse (das)",
          "Shumës (die)"
        ],
        "rows": [
          [
            "Nominativ",
            "einer / keiner / meiner",
            "eine / keine / meine",
            "eins / keins / meins",
            "welche / keine / meine"
          ],
          [
            "Akkusativ",
            "einen / keinen / meinen",
            "eine / keine / meine",
            "eins / keins / meins",
            "welche / keine / meine"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Was möchten Sie trinken? — Ich möchte einen Kaffee. — Ich möchte auch einen.",
        "alb": "Çfarë dëshironi të pini? — Dua një kafe. — Edhe unë dua një."
      },
      {
        "ger": "Einer von meinen Freunden ist verheiratet.",
        "alb": "Njëri nga miqtë e mi është i martuar."
      },
      {
        "ger": "Keiner von uns lebt in Amerika.",
        "alb": "Asnjëri prej nesh nuk jeton në Amerikë."
      }
    ],
    "exercises": [
      {
        "question": "Hast du einen Kuli? — Ja, hier ist ...",
        "options": [
          "einer",
          "einen",
          "eins"
        ],
        "correct": 0,
        "explanation": "Në fjalinë 'Hier ist ...', kërkohet Nominativ mashkullor (der Kuli), prandaj përdoret 'einer'."
      },
      {
        "question": "Ich brauche ein Wörterbuch. Hast du ...?",
        "options": [
          "einer",
          "einen",
          "eins"
        ],
        "correct": 2,
        "explanation": "'Das Wörterbuch' është asnjëanës (das), kështu që në Akkusativ merr formën 'eins'."
      }
    ]
  },
  {
    "id": "a2_4_wenn_sollten",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.4 — Konjunktion 'wenn' (nëse) ; Sollten im Konjunktiv II",
    "description": "Lidhëza wenn (Hauptsatz vs. Nebensatz) dhe zgjedhimi i foljes modalen sollten për të dhënë këshilla e rekomandime.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Konjunktion \"wenn\" (nëse / kur)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                <b>Hauptsatz</b>: fjali kryesore që qëndron e vetme.<br/>\n                <b>Nebensatz</b>: fjali e varur që bashkëngjitet me 'wenn', ku <b>folja shkon gjithmonë në fund</b>.\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Ich kann Ihnen kein Zimmer geben, <b>wenn Sie keine Bestätigung haben</b>.</i></li>\n              <li><i><b>Wenn Sie keine Bestätigung haben</b>, (dann) <b>kann ich</b> Ihnen kein Zimmer geben.</i> (Kur fillon me 'wenn', pas presjes vjen menjëherë folja e fjalisë kryesore!)</li>\n              <li><i>Ich bleibe im Bett, <b>wenn ich krank bin</b>.</i> &harr; <i><b>Wenn ich krank bin</b>, bleibe ich im Bett.</i></li>\n              <li><i>Ich nehme einen Regenschirm mit, <b>wenn es regnet</b>.</i> &harr; <i><b>Wenn es regnet</b>, nehme ich einen Regenschirm mit.</i></li>\n            </ul>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-6\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Sollten (Sollen im Konjunktiv II) — Këshilla nga zemra</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Ndryshe nga <b>sollen</b> që tingëllon më ashpër dhe shpreh urdhër, forma <b>sollten</b> shpreh një këshillë dashamirëse ose rekomandim (Du solltest = Ti duhet të...).\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Du <b>solltest</b> Detektiv werden.</i> (Ti duhet të bëheshe detektiv.)</li>\n              <li><i>Sie <b>sollte</b> früh ins Bett gehen.</i> (Ajo duhet të shkonte herët në shtrat.)</li>\n              <li><i>Wir <b>sollten</b> nicht laut sprechen.</i> (Ne nuk duhet të flasim me zë të lartë.)</li>\n              <li><i>Die Kinder <b>sollten</b> nicht Fußball spielen.</i></li>\n              <li><i>Sie <b>sollten</b> nicht unhöflich werden.</i></li>\n            </ul>\n          </section>\n        ",
    "tables": [
      {
        "label": "Zgjedhimi i foljes 'sollten' (Konjunktiv II)",
        "headers": [
          "Përemri",
          "Forma",
          "Prapashtesa"
        ],
        "rows": [
          [
            "Ich",
            "sollte",
            "-e"
          ],
          [
            "Du",
            "solltest",
            "-est"
          ],
          [
            "Er / sie / es",
            "sollte",
            "-e"
          ],
          [
            "Wir",
            "sollten",
            "-en"
          ],
          [
            "Ihr",
            "solltet",
            "-et"
          ],
          [
            "Sie / sie",
            "sollten",
            "-en"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Wenn ich krank bin, bleibe ich im Bett.",
        "alb": "Nëse jam i sëmurë, unë rri në shtrat."
      },
      {
        "ger": "Du solltest mehr schlafen und dich ausruhen.",
        "alb": "Ti duhet të flesh më shumë dhe të pushosh."
      },
      {
        "ger": "Wenn es regnet, nehme ich einen Regenschirm mit.",
        "alb": "Nëse bie shi, unë marr një çadër me vete."
      }
    ],
    "exercises": [
      {
        "question": "Zgjidh vazhdimin e saktë: Wenn du Kopfschmerzen hast, ...",
        "options": [
          "du solltest eine Tablette nehmen",
          "solltest du eine Tablette nehmen",
          "du eine Tablette nehmen solltest"
        ],
        "correct": 1,
        "explanation": "Kur fjalia e nënrenditur me 'wenn' është e para, fjalia kryesore fillon menjëherë me foljen: 'solltest du'."
      }
    ]
  },
  {
    "id": "a2_5_reflexive_verben_praepositionen",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.5 — Reflexive Verben ; Foljet me Parafjalë ; Präpositionaladverbien",
    "description": "Foljet vetvetore (sich waschen, sich freuen), foljet me parafjalë fikse (sich interessieren für) dhe pyetjet wofür/dafür, worüber/darüber.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Reflexive Verben (Foljet vetvetore)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Vepruesi e kryen vetë veprimin dhe vetë e pëson: <i>Ich wasche mich</i> (Unë lahem).<br/>\n                Përemrat refleksivë zënë zakonisht <b>pozicionin e 3-të</b> në fjali: <i>Ich fühle mich müde.</i> / <i>Du solltest dich gesund ernähren.</i>\n              </p>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Verben mit Präpositionen (Foljet me parafjalë fikse)</h4>\n              <ul class=\"text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>sich interessieren + für (Akk.)</b>: <i>Ich interessiere mich für Fußball.</i></li>\n                <li>&bull; <b>sich beschweren + über (Akk.)</b>: <i>Ich beschwere mich über das Wetter.</i></li>\n                <li>&bull; <b>sich erinnern + an (Akk.)</b>: <i>Ich erinnere mich an meine Kindheit.</i></li>\n                <li>&bull; <b>sich treffen + mit (Dat.)</b>: <i>Ich treffe mich mit meinem Freund.</i></li>\n                <li>&bull; <b>sprechen + mit (Dat.) / über (Akk.)</b>: <i>Ich spreche mit ihm über den Beruf.</i></li>\n                <li>&bull; <b>warten + auf (Akk.)</b>: <i>Ich warte auf den Bus.</i></li>\n                <li>&bull; <b>sich kümmern + um (Akk.)</b>: <i>Ich kümmere mich um die Blumen.</i></li>\n                <li>&bull; <b>Lust haben + auf (Akk.)</b>: <i>Ich habe Lust auf Tanzen.</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Präpositionaladverbien (da- / wo-)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Për sende dhe koncepte përdorim kombinimet me <b>da(r)-</b> dhe <b>wo(r)-</b>:<br/>\n                &bull; <i>Wofür interessierst du dich? &rarr; Ich interessiere mich für Medizin. / Ich interessiere mich auch <b>dafür</b>.</i><br/>\n                &bull; <i>Worüber beschwerst du dich? &rarr; Ich beschwere mich <b>darüber</b>.</i><br/>\n                &bull; <i>Worauf wartest du? &rarr; Ich warte <b>darauf</b>.</i><br/>\n                &bull; <i>Woran erinnerst du dich? &rarr; Ich erinnere mich <b>daran</b>.</i>\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Zgjedhimi i përemrit vetvetor (sich bewegen)",
        "headers": [
          "Njëjës",
          "Forma",
          "Shumës",
          "Forma"
        ],
        "rows": [
          [
            "Ich",
            "bewege mich",
            "Wir",
            "bewegen uns"
          ],
          [
            "Du",
            "bewegst dich",
            "Ihr",
            "bewegt euch"
          ],
          [
            "Er / sie / es",
            "bewegt sich",
            "Sie / sie",
            "bewegen sich"
          ]
        ]
      },
      {
        "label": "Përemrat ndajfoljorë dhe pyetësit përkatës",
        "headers": [
          "Përgjigje me da(r)- (për të)",
          "Pyetje me wo(r)- (për çka?)",
          "Parafjala bazë"
        ],
        "rows": [
          [
            "dafür",
            "wofür?",
            "für"
          ],
          [
            "darüber",
            "worüber?",
            "über"
          ],
          [
            "daran",
            "woran?",
            "an"
          ],
          [
            "darauf",
            "worauf?",
            "auf"
          ],
          [
            "damit",
            "womit?",
            "mit"
          ],
          [
            "davon",
            "wovon?",
            "von"
          ],
          [
            "darum",
            "worum?",
            "um"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Ich interessiere mich für Fußball. Interessierst du dich auch dafür?",
        "alb": "Unë interesohem për futboll. A interesohesh edhe ti për të?"
      },
      {
        "ger": "Worauf hast du Lust? — Ich habe Lust auf Pizza.",
        "alb": "Për çfarë ke qejf? — Kam qejf për pica."
      },
      {
        "ger": "Er ruht sich nach der Arbeit aus.",
        "alb": "Ai po pushon pas punës."
      }
    ],
    "exercises": [
      {
        "question": "Plotëso: Ich erinnere mich gut ... meine Schulzeit.",
        "options": [
          "an",
          "für",
          "über"
        ],
        "correct": 0,
        "explanation": "Folja 'sich erinnern' lidhet gjithmonë me parafjalën 'an + Akkusativ'."
      },
      {
        "question": "... wartest du? — Auf den Bus.",
        "options": [
          "Wofür",
          "Worauf",
          "Worüber"
        ],
        "correct": 1,
        "explanation": "'Warten auf' formon pyetjen për sende me 'Worauf?'."
      }
    ]
  },
  {
    "id": "a2_6_modalverben_praeteritum_dass",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.6 — Modalverben im Präteritum ; Konjunktion 'dass'",
    "description": "Zgjedhimi në Präteritum i 6 foljeve modale (musste, konnte, wollte, durfte, sollte, mochte) dhe lidhëza dass.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Modalverben im Präteritum</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Në gjuhën gjermane janë gjithsej 6 folje modale. Në kohën e kaluar të thjeshtë (Präteritum) ato <b>humbin të gjitha pikët e umlautit (&auml;, &ouml;, &uuml;)</b>:\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>müssen &rarr; ich musste</b> (obligim / detyrim)</li>\n                <li>&bull; <b>können &rarr; ich konnte</b> (mundësi / aftësi)</li>\n                <li>&bull; <b>wollen &rarr; ich wollte</b> (qëllim / dëshirë e fortë)</li>\n                <li>&bull; <b>dürfen &rarr; ich durfte</b> (lejim / me 'nicht': ndalim)</li>\n                <li>&bull; <b>sollen &rarr; ich sollte</b> (obligim moral / këshillë)</li>\n                <li>&bull; <b>mögen &rarr; ich mochte</b> (pëlqim / dëshirë)</li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Konjunktion \"dass\" (Lidhëza \"që\")</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Lidhëza <b>dass</b> lidh fjalinë kryesore (Hauptsatz) me fjalinë e nënrenditur (Nebensatz). <b>Folja e zgjedhuar shkon gjithmonë në fund!</b>\n              </p>\n            </div>\n            <ul class=\"list-disc pl-5 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n              <li><i>Es ist wichtig, <b>dass</b> man einen guten Schulabschluss <b>hat</b>.</i></li>\n              <li><i>Ich weiß, <b>dass</b> du keine Zeit <b>hast</b>.</i></li>\n              <li><i>Ich hoffe, <b>dass</b> ich dich bald <b>wiedersehe</b>.</i> (Foljet e ndashme bashkohen në fund!)</li>\n              <li><i>Sie denkt nicht, <b>dass</b> er verheiratet sein <b>will</b>.</i> (Me folje modale: folja modale rri në fund fare!)</li>\n              <li><i>Wir wissen, <b>dass</b> wir sie getroffen <b>haben</b>.</i></li>\n            </ul>\n          </section>\n        ",
    "tables": [
      {
        "label": "Zgjedhimi i Foljeve Modale në Präteritum",
        "headers": [
          "Përemri",
          "müssen",
          "können",
          "wollen",
          "dürfen",
          "sollen"
        ],
        "rows": [
          [
            "Ich",
            "musste",
            "konnte",
            "wollte",
            "durfte",
            "sollte"
          ],
          [
            "Du",
            "musstest",
            "konntest",
            "wolltest",
            "durftest",
            "solltest"
          ],
          [
            "Er / sie / es",
            "musste",
            "konnte",
            "wollte",
            "durfte",
            "sollte"
          ],
          [
            "Wir",
            "mussten",
            "konnten",
            "wollten",
            "durften",
            "sollten"
          ],
          [
            "Ihr",
            "musstet",
            "konntet",
            "wolltet",
            "durftet",
            "solltet"
          ],
          [
            "Sie / sie",
            "mussten",
            "konnten",
            "wollten",
            "durften",
            "sollten"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Gestern konnte ich nicht kommen, weil ich arbeiten musste.",
        "alb": "Dje nuk munda të vija, sepse m'u desh të punoja."
      },
      {
        "ger": "Ich weiß, dass du fleißig Deutsch lernst.",
        "alb": "E di që po mëson gjermanisht me zell."
      },
      {
        "ger": "Als Kind durfte ich nicht lange draußen bleiben.",
        "alb": "Si fëmijë nuk më lejohej të rrija gjatë jashtë."
      }
    ],
    "exercises": [
      {
        "question": "Zgjidh formën e saktë: Gestern ... wir nicht ins Kino gehen, weil wir lernen mussten.",
        "options": [
          "konnten",
          "könnten",
          "gekonnt"
        ],
        "correct": 0,
        "explanation": "Präteritum për 'wir können' është 'konnten' (pa umlaut)."
      }
    ]
  },
  {
    "id": "a2_7_dativ_objekt_von",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.7 — Dativ als Objekt ; Renditja e Kundrinave ; Parafjala 'von'",
    "description": "Dhanorja si kundrinë e drejtë/zhdrrejtë për frymorë, rregullat e sintaksës për renditjen e Dativ dhe Akkusativ, dhe parafjala von.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Dativ als Objekt (Dhanorja si kundrinë)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Dativi i përgjigjet pyetjes <b>WEM?</b> (Kujt?) dhe zakonisht përdoret për persona (frymorë) që e pranojnë veprimin tonë:<br/>\n                <i>Ich kaufe <b>meinem Baby</b> (Dativ) einen Teddy (Akkusativ).</i>\n              </p>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Syntax &mdash; Stellung der Objekte (Renditja në fjali)</h4>\n              <ul class=\"text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>Rregulli 1 (Dy emra): Dativ para Akkusativ!</b><br/>\n                <i>Holger gibt <b>seiner Frau</b> (Dativ) <b>einen Kuss</b> (Akkusativ).</i></li>\n                <li>&bull; <b>Rregulli 2 (Një përemër dhe një emër): Përemri del gjithmonë i pari!</b><br/>\n                <i>Holger gibt <b>ihr</b> (Pronomen) <b>einen Kuss</b> (Nomen).</i></li>\n                <li>&bull; <b>Rregulli 3 (Dy përemra): Akkusativ para Dativ!</b><br/>\n                <i>Holger gibt <b>ihn</b> (Akkusativ) <b>ihr</b> (Dativ).</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Präposition \"von\" (+ Dativ)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Parafjala <b>von</b> do të thotë 'nga / prej' dhe kërkon gjithmonë rasën <b>Dativ</b>:<br/>\n                &bull; <i>Ich komme <b>von ihm</b>.</i><br/>\n                &bull; <i>Ich komme <b>von der Uni</b>.</i><br/>\n                &bull; <i>Die Stadt wurde <b>von einem starken Erdbeben</b> zerstört.</i>\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Deklinimi i nyjeve dhe përemrave në Dativ",
        "headers": [
          "Gjinia",
          "Nyja e shquar",
          "Nyja e pashquar",
          "Përemri vetor (Dativ)"
        ],
        "rows": [
          [
            "Maskulin",
            "dem Mann",
            "einem Mann",
            "ihm"
          ],
          [
            "Feminin",
            "der Frau",
            "einer Frau",
            "ihr"
          ],
          [
            "Neutral",
            "dem Kind",
            "einem Kind",
            "ihm"
          ],
          [
            "Plural",
            "den Kindern (+n)",
            "meinen Kindern",
            "ihnen / Ihnen"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Ich gebe meinem Mann eine Blume.",
        "alb": "Unë i jap burrit tim një lule."
      },
      {
        "ger": "Ich gebe ihm eine Blume.",
        "alb": "Unë i jap atij një lule."
      },
      {
        "ger": "Ich gebe sie ihm.",
        "alb": "Unë ia jap atë atij. (Akkusativ-Pronomen para Dativ-Pronomen)"
      }
    ],
    "exercises": [
      {
        "question": "Nëse zëvendësojmë me përemra fjalinë 'Er schenkt der Mutter das Buch':",
        "options": [
          "Er schenkt es ihr.",
          "Er schenkt ihr es.",
          "Er schenkt sie ihm."
        ],
        "correct": 0,
        "explanation": "Kur të dyja kundrinat janë përemra vetorë, Akkusativi (es) vendoset para Dativit (ihr): 'Er schenkt es ihr'."
      }
    ]
  },
  {
    "id": "a2_8_konjunktiv2_trotzdem",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.8 — Konjunktiv II (wäre, hätte, würde) ; Adverb 'trotzdem'",
    "description": "Mënyra dëshirore (wäre gern, hätte gern, würde + Infinitiv, könnten) dhe ndajfolja lidhëze trotzdem (megjithatë).",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Konjunktiv II &mdash; Mënyra dëshirore</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Përdoret për dëshira, ëndrra dhe gjendje hipotetike në të tashmen:\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>sein &rarr; wäre gern / wäre lieber</b> (do të isha me qejf):<br/>\n                <i>Ich bin ein Lehrer, aber ich <b>wäre gern</b> ein Arzt.</i><br/>\n                <i>Wir sind in Kosova, aber wir <b>wären lieber</b> in der Schweiz.</i></li>\n                <li>&bull; <b>haben &rarr; hätte gern / hätte lieber</b> (do të kisha me qejf):<br/>\n                <i>Ich habe ein Handy, aber ich <b>hätte gern</b> einen Computer.</i><br/>\n                <i>Wir haben ein Haus, aber wir <b>hätten lieber</b> zwei.</i></li>\n                <li>&bull; <b>Për të gjitha foljet tjera: würde + Infinitiv</b> (anglisht: would):<br/>\n                <i>Ich arbeite sehr viel, aber ich <b>würde gern nicht arbeiten</b>.</i><br/>\n                <i>Ich <b>würde gern</b> mit meiner Schwester essen gehen.</i></li>\n                <li>&bull; <b>Propozime miqësore me 'könnten'</b>:<br/>\n                <i>Wir <b>könnten</b> ins Kino gehen.</i> / <i>Du <b>könntest</b> Detektiv werden.</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Trotzdem (Megjithatë)</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Përdoret kur dy fjali bien në kundërshtim me njëra-tjetrën. Pas <b>trotzdem</b> vjen <b>menjëherë folja</b> (Inversion):\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <i>Ich muss lernen. <b>Trotzdem spiele</b> ich Fußball.</i> (ose: <i>Ich spiele trotzdem Fußball.</i>)</li>\n                <li>&bull; <i>Ich habe kein Geld. <b>Trotzdem kaufe</b> ich mir ein Handy.</i></li>\n                <li>&bull; <i>Meine Wohnung ist klein. <b>Trotzdem mag</b> ich sie.</i></li>\n                <li>&bull; <i>Ich möchte jetzt schlafen. <b>Trotzdem muss</b> ich die Hausaufgaben machen.</i></li>\n              </ul>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Zgjedhimi në Konjunktiv II: wäre, hätte, würde",
        "headers": [
          "Përemri",
          "sein (wäre)",
          "haben (hätte)",
          "werden (würde + Inf)"
        ],
        "rows": [
          [
            "Ich",
            "wäre gern",
            "hätte gern",
            "würde"
          ],
          [
            "Du",
            "wär(e)st gern",
            "hättest gern",
            "würdest"
          ],
          [
            "Er / sie / es",
            "wäre gern",
            "hätte gern",
            "würde"
          ],
          [
            "Wir",
            "wären gern",
            "hätten gern",
            "würden"
          ],
          [
            "Ihr",
            "wär(e)t gern",
            "hättet gern",
            "würdet"
          ],
          [
            "Sie / sie",
            "wären gern",
            "hätten gern",
            "würden"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Was würden Sie tun, wenn Sie 1 Million Euro hätten?",
        "alb": "Çfarë do të bënit ju, po të kishit 1 milion euro?"
      },
      {
        "ger": "Es regnet in Strömen. Trotzdem gehen wir spazieren.",
        "alb": "Bie shi me rrëshekë. Megjithatë ne po dalim shëtitje."
      }
    ],
    "exercises": [
      {
        "question": "Plotëso: Ich habe viel zu tun. ... helfe ich dir gern.",
        "options": [
          "Weil",
          "Trotzdem",
          "Denn"
        ],
        "correct": 1,
        "explanation": "'Trotzdem' tregon veprim në kundërshtim me situatën (Kam shumë punë, megjithatë të ndihmoj)."
      }
    ]
  },
  {
    "id": "a2_9_deklination_unbestimmt_komparation",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.9 — Deklination der unbestimmten Adjektive ; Komparation ; als/wie",
    "description": "Lakimi i mbiemrave me nyjen e pashquar (ein guter Mann), shkallët e mbiemrave (Positiv, Komparativ, Superlativ) dhe krahasimi me wie e als.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Lakimi i mbiemrave me nyje të pashquar (ein / eine / ein)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Në Nominativ dhe Akkusativ, mbiemri merr mbaresën e nyjes së shquar përkatëse (-er për der, -es për das, -e për die). Në Dativ, të gjitha mbiemrat marrin mbaresën <b>-en</b>!\n              </p>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Komparation der Adjektive (Shkallët e mbiemrit)</h4>\n              <ul class=\"text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>Positiv &rarr; Komparativ (-er) &rarr; Superlativ (am ...-sten)</b></li>\n                <li>&bull; <i>schön &rarr; schöner &rarr; am schönsten</i></li>\n                <li>&bull; <i>interessant &rarr; interessanter &rarr; am interessantesten</i> (mbaron me -t/-d &rarr; <b>-esten</b>)</li>\n                <li>&bull; <i>groß &rarr; größer &rarr; am größten</i> (me umlaut)</li>\n                <li>&bull; <i>hoch &rarr; höher &rarr; am höchsten</i> (e parregullt: 'c' bie në komparativ!)</li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Vergleichspartikel: wie vs. als</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                &bull; <b>wie (si, sa)</b>: kur dy gjëra të krahasuara janë <b>të barabarta / të njëjta</b> (so ... wie):<br/>\n                <i>Du bist <b>so groß wie</b> meine Schwester.</i> / <i>Er ist <b>genauso schlau wie</b> mein Bruder.</i><br/>\n                &bull; <b>als (se)</b>: kur dy gjëra janë <b>të ndryshme</b> dhe mbiemri është në shkallën krahasore (Komparativ + als):<br/>\n                <i>Sie ist <b>älter als</b> meine Schwester.</i> / <i>Ihr Haus ist <b>kleiner als</b> unseres.</i>\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Lakimi i mbiemrave me nyjen e pashquar (ein/eine)",
        "headers": [
          "Rasa",
          "Mashkullore (der)",
          "Femërore (die)",
          "Asnjëanëse (das)",
          "Shumës (viele)"
        ],
        "rows": [
          [
            "Nominativ",
            "ein schöner Stuhl (-er)",
            "eine schöne Tasche (-e)",
            "ein schönes Buch (-es)",
            "viele schöne Sachen (-e)"
          ],
          [
            "Akkusativ",
            "einen schönen Stuhl (-en)",
            "eine schöne Tasche (-e)",
            "ein schönes Buch (-es)",
            "viele schöne Sachen (-e)"
          ],
          [
            "Dativ",
            "mit einem schönen Stuhl (-en)",
            "mit einer schönen Tasche (-en)",
            "mit einem schönen Buch (-en)",
            "mit vielen schönen Sachen (-en)"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Du bist so groß wie meine Schwester.",
        "alb": "Ti je aq i/e gjatë sa motra ime."
      },
      {
        "ger": "Er ist älter als sein Bruder.",
        "alb": "Ai është më i vjetër se vëllai i tij."
      },
      {
        "ger": "Ich habe ein interessantes Buch gelesen.",
        "alb": "Kam lexuar një libër interesant."
      }
    ],
    "exercises": [
      {
        "question": "Plotëso: Mein Auto ist schneller ... deins.",
        "options": [
          "als",
          "wie",
          "so"
        ],
        "correct": 0,
        "explanation": "Pas shkallës krahasore (schneller) përdoret gjithmonë 'als'."
      }
    ]
  },
  {
    "id": "a2_10_passiv_bestimmte_adjektive",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.10 — Das Passiv ; Frageartikel 'was für ein' ; Bestimmte Adjektive",
    "description": "Diateza pësore në të tashmen (werden + Partizip II), pyetësi Was für ein...? dhe lakimi i mbiemrave me nyje të shquar (der gute Tisch).",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Das Passiv (Pësorja në gjuhën gjermane)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Formula e diatezës pësore në kohën e tashme: <b>werden (Präsens) + Partizip II</b>.<br/>\n                &bull; Njëjës: <b>wird + Partizip II</b> &rarr; <i>Das Auto <b>wird</b> repariert.</i> (Makina riparohet)<br/>\n                &bull; Shumës: <b>werden + Partizip II</b> &rarr; <i>Die Autos <b>werden</b> repariert.</i> (Makinat riparohen)<br/>\n                Nëse përmendet kryesi i veprimit, përdoret <b>von + Dativ</b>: <i>Das Auto wird <b>von dem Mechaniker</b> repariert.</i>\n              </p>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Frageartikel: Was für ein...? (Çfarë lloj...?)</h4>\n              <ul class=\"text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; Njëjës: <b>Was für ein / eine / einen ...?</b><br/>\n                <i>Was für einen Film hast du gesehen?</i> / <i>Was für eine Tasche ist das?</i></li>\n                <li>&bull; Shumës: <b>Was für ...?</b> (pa ein!)<br/>\n                <i>Was für Menschen sind das?</i> / <i>Was für Sachen hast du gekauft?</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Lakimi i mbiemrave me nyje të shquar (der / die / das)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Rregulli kryesor: Mbaresa është ose <b>-e</b> ose <b>-en</b>!<br/>\n                &bull; Merr <b>-e</b> vetëm në Nominativ (të 3 gjinitë njëjës) dhe në Akkusativ (femërore dhe asnjëanëse).<br/>\n                &bull; Merr <b>-en</b> në Akkusativ mashkullor, në të gjithë Dativin dhe në të gjithë Shumësin!\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Lakimi i mbiemrave me nyje të shquar (der/die/das)",
        "headers": [
          "Rasa",
          "Mashkullore",
          "Femërore",
          "Asnjëanëse",
          "Shumës"
        ],
        "rows": [
          [
            "Nominativ",
            "der gute Tisch (-e)",
            "die gute Tasche (-e)",
            "das gute Buch (-e)",
            "die guten Sachen (-en)"
          ],
          [
            "Akkusativ",
            "den guten Tisch (-en)",
            "die gute Tasche (-e)",
            "das gute Buch (-e)",
            "die guten Sachen (-en)"
          ],
          [
            "Dativ",
            "dem guten Tisch (-en)",
            "der guten Tasche (-en)",
            "dem guten Buch (-en)",
            "den guten Sachen (-en)"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Das Auto wird von ihm gekauft.",
        "alb": "Makina blihet nga ai."
      },
      {
        "ger": "Was für ein schönes Kleid trägst du!",
        "alb": "Çfarë fustani të bukur ke veshur!"
      },
      {
        "ger": "Der schöne Stuhl gefällt mir sehr gut.",
        "alb": "Karrigia e bukur më pëlqen shumë."
      }
    ],
    "exercises": [
      {
        "question": "Forma korrekte në pasiv: Das Haus ... von den Arbeitern gebaut.",
        "options": [
          "wird",
          "werden",
          "hat"
        ],
        "correct": 0,
        "explanation": "Për subjektin në njëjës (Das Haus) përdoret 'wird + Partizip II'."
      }
    ]
  },
  {
    "id": "a2_11_lokale_praepositionen_deshalb",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.11 — Lokale Präpositionen ; Ndajfolja 'deshalb' ; Fjalëformimi",
    "description": "Parafjalët e lëvizjes dhe qëndrimit (zu/in/aus, zu/bei/von), përdorimi i deshalb dhe prapashtesat -bar, -isch, -ig.",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Lokale Präpositionen (Parafjalët e vendit sipas kontekstit)</h4>\n              <ul class=\"text-sm space-y-2 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>Për persona dhe profesione</b>: <i>gehen <b>zu</b> &bull; sein <b>bei</b> &bull; kommen <b>von</b></i> (+ Dativ):<br/>\n                <i>Ich gehe zum Arzt / Ich bin beim Arzt / Ich komme vom Arzt.</i><br/>\n                <i>Ich gehe zu Kaltrina / Ich bin bei Kaltrina / Ich komme von Kaltrina.</i></li>\n                <li>&bull; <b>Për ndërtesa dhe hapësira të mbyllura</b>: <i>gehen <b>in</b> (Akk) &bull; sein <b>in</b> (Dat) &bull; kommen <b>aus</b> (Dat)</i>:<br/>\n                <i>Ich gehe in die Klasse / Ich bin in der Klasse / Ich komme aus der Klasse.</i><br/>\n                <i>Ich gehe ins Restaurant / Ich bin im Restaurant / Ich komme aus dem Restaurant.</i></li>\n                <li>&bull; <b>Për vende dhe hapësira të hapura</b>: <i>gehen <b>auf</b> (Akk) &bull; sein <b>auf</b> (Dat) &bull; kommen <b>von</b> (Dat)</i>:<br/>\n                <i>Ich gehe auf den Sportplatz / Ich bin auf dem Sportplatz / Ich komme vom Sportplatz.</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Deshalb (Prandaj / Andaj / Për këtë arsye)</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Lidh dy fjali kur e dyta tregon pasojën logjike të së parës. Pas <b>deshalb</b> folja merr pozitën e dytë: <b>Deshalb + Verb + Subjekt</b>.\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <i>Ich lebe in Deutschland. <b>Deshalb lerne</b> ich Deutsch.</i></li>\n                <li>&bull; <i>Ich bin krank. <b>Deshalb gehe</b> ich zur Ärztin.</i></li>\n                <li>&bull; <i>Ich habe Hunger. <b>Deshalb gehe</b> ich ins Restaurant.</i></li>\n                <li>&bull; <i>Er geht in den Supermarkt. <b>Deshalb muss</b> er etwas kaufen.</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Wortbildung (Fjalëformimi i mbiemrave)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                &bull; <b>Folje + -bar</b>: <i>benutzen &rarr; benutzbar</i> (i përdorshëm), <i>tragen &rarr; tragbar</i> (i bartshëm).<br/>\n                &bull; <b>Emër + -isch / -ig</b>: <i>der Sturm &rarr; stürmisch</i> (me stuhi), <i>das Eis &rarr; eisig</i> (i akullt), <i>der Regen &rarr; regnerisch</i> (me shi), <i>das Gewitter &rarr; gewittrig</i>.\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Treshja e parafjalëve të vendit",
        "headers": [
          "Destinacioni",
          "Drejtimi (Wohin?)",
          "Gjendja (Wo?)",
          "Origjina (Woher?)"
        ],
        "rows": [
          [
            "Person / Emër njeriu",
            "zu + Dativ (zum / zur)",
            "bei + Dativ (beim / bei der)",
            "von + Dativ (vom / von der)"
          ],
          [
            "Ndërtesë / Dhomë",
            "in + Akkusativ (ins / in die)",
            "in + Dativ (im / in der)",
            "aus + Dativ (aus dem / aus der)"
          ],
          [
            "Hapësirë e hapur",
            "auf + Akkusativ (aufs / auf die)",
            "auf + Dativ (auf dem / auf der)",
            "von + Dativ (vom / von der)"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Ich gehe zum Arzt, weil ich Halsschmerzen habe.",
        "alb": "Po shkoj te mjeku sepse më dhemb fyti."
      },
      {
        "ger": "Ich bin müde. Deshalb gehe ich früh ins Bett.",
        "alb": "Jam i lodhur. Prandaj po shkoj herët në shtrat."
      }
    ],
    "exercises": [
      {
        "question": "Ku po shkon ti? — Ich gehe ... Großmutter.",
        "options": [
          "zur",
          "bei der",
          "aus der"
        ],
        "correct": 0,
        "explanation": "Për lëvizje drejt një personi përdoret 'zu + Dativ' (zu der = zur)."
      }
    ]
  },
  {
    "id": "a2_12_lokale_wasser_land_nullartikel",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.12 — Lokale Präpositionen (Uji & Toka) ; Adjektive ohne Artikel",
    "description": "Parafjalët për detin, lumin e bregdetin (an/in), malet e ishujt (auf/in) dhe lakimi i mbiemrave pa nyje (guter Kaffee).",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Parafjalët e vendit për Ujin (Wasser)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Gjithçka që ka të bëjë me buzë ujit merr parafjalën <b>an</b>. Nëse jemi brenda në ujë, përdoret <b>in</b> (im Meer):\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <i>an den See (Akk) / am See (Dat)</i> &bull; <i>an den Strand (Akk) / am Strand (Dat)</i></li>\n                <li>&bull; <i>ans Meer (Akk) / am Meer (Dat)</i> &bull; <i>an die Küste (Akk) / an der Küste (Dat)</i></li>\n                <li>&bull; <i>an den Fluss (Akk) / am Fluss (Dat)</i> &bull; <i>an die Mosel (Akk) / an der Mosel (Dat)</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Parafjalët për Tokën dhe Malet (Land & Gebirge)</h4>\n              <ul class=\"text-sm space-y-1 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <b>auf</b>: <i>auf den Berg (Akk) / auf dem Berg (Dat)</i> &bull; <i>auf die Insel / auf der Insel</i> &bull; <i>aufs Land / auf dem Land</i></li>\n                <li>&bull; <b>in</b>: <i>in die Berge / in den Bergen</i> &bull; <i>in den Süden / im Süden</i> &bull; <i>in die Wüste / in der Wüste</i> &bull; <i>ins Gebirge / im Gebirge</i></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Lakimi i mbiemrave pa nyje (Nullartikel)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Kur emri nuk ka para asnjë nyje, mbiemri merr vetë <b>mbaresën e nyjes së shquar</b> (der &rarr; -er, das &rarr; -es, die &rarr; -e, dem &rarr; -em):<br/>\n                &bull; <i>ein guter Mann &rarr; <b>guter Mann</b></i> (Burrë i mirë)<br/>\n                &bull; <i>ein schönes Buch &rarr; <b>schönes Buch</b></i> (Libër i bukur)<br/>\n                &bull; <i>frische Milch &rarr; mit <b>frischer Milch</b></i>\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Lakimi i mbiemrave pa nyje (Nullartikel)",
        "headers": [
          "Rasa",
          "Mashkullore",
          "Femërore",
          "Asnjëanëse",
          "Shumës"
        ],
        "rows": [
          [
            "Nominativ",
            "guter Mann (-er)",
            "gute Frau (-e)",
            "gutes Buch (-es)",
            "gute Sachen (-e)"
          ],
          [
            "Akkusativ",
            "guten Mann (-en)",
            "gute Frau (-e)",
            "gutes Buch (-es)",
            "gute Sachen (-e)"
          ],
          [
            "Dativ",
            "gutem Mann (-em)",
            "guter Frau (-er)",
            "gutem Buch (-em)",
            "guten Sachen (-en)"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Im Sommer fahren wir ans Meer und liegen am Strand.",
        "alb": "Në verë shkojmë në det dhe rrimë shtrirë në plazh."
      },
      {
        "ger": "Wir trinken heißen Kaffee und essen frisches Brot.",
        "alb": "Po pimë kafe të nxehtë dhe po hamë bukë të freskët."
      }
    ],
    "exercises": [
      {
        "question": "Wohin fährst du im Urlaub? — Ich fahre ... Meer.",
        "options": [
          "ans",
          "am",
          "auf"
        ],
        "correct": 0,
        "explanation": "'An das Meer' shkurtohet në 'ans Meer' (Akkusativ për drejtim)."
      }
    ]
  },
  {
    "id": "a2_13_indirekte_fragen_lassen",
    "category": "a2_notes",
    "level": "A2",
    "title": "A2.13 — Indirekte Fragen (Pyetjet Indirekte) ; Folja 'lassen'",
    "description": "Pyetjet indirekte me pyetës W dhe me lidhëzën ob, si dhe përdorimi e zgjedhimi i foljes lassen (le diçka të bëhet nga dikush tjetër).",
    "detailedContent": "\n          <section class=\"space-y-4\">\n            <div class=\"rounded-xl border-l-4 border-amber-500 bg-amber-50/60 p-4 dark:bg-amber-950/20\">\n              <h4 class=\"font-bold text-amber-900 dark:text-amber-200\">1. Indirekte W-Fragen (Pyetjet indirekte me fjalë pyetëse)</h4>\n              <p class=\"text-sm text-amber-800 dark:text-amber-300\">\n                Pyetjet indirekte janë më të sjellshme. Tek këto pyetje, <b>folja shkon gjithmonë në fund të fjalisë</b>:\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <i>Was machen Sie?</i> &rarr; <b>Können Sie mir sagen, was Sie machen?</b></li>\n                <li>&bull; <i>Wohin gehst du?</i> &rarr; <b>Darf ich fragen, wohin du gehst?</b></li>\n                <li>&bull; <i>Woher kommt er?</i> &rarr; <b>Darf ich wissen, woher er kommt?</b></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-blue-500 bg-blue-50/60 p-4 dark:bg-blue-950/20 mt-4\">\n              <h4 class=\"font-bold text-blue-900 dark:text-blue-200\">2. Indirekte Ja/Nein-Fragen me lidhëzën \"ob\" (a / nëse)</h4>\n              <p class=\"text-sm text-blue-800 dark:text-blue-300\">\n                Nëse pyetja direkte nuk ka fjalë pyetëse W (fillon me folje), pyetja indirekte fillon me <b>ob</b> dhe folja shkon në fund:\n              </p>\n              <ul class=\"mt-2 text-sm space-y-1.5 text-zinc-700 dark:text-zinc-300\">\n                <li>&bull; <i>Hast du die Hausaufgaben gemacht?</i> &rarr; <b>Könntest du mir sagen, ob du die Hausaufgaben gemacht hast?</b></li>\n                <li>&bull; <i>Bist du jetzt zu Hause?</i> &rarr; <b>Darf ich wissen, ob du jetzt zu Hause bist?</b></li>\n                <li>&bull; <i>Kommen Sie morgen?</i> &rarr; <b>Darf ich Sie fragen, ob Sie morgen kommen?</b></li>\n              </ul>\n            </div>\n\n            <div class=\"rounded-xl border-l-4 border-emerald-500 bg-emerald-50/60 p-4 dark:bg-emerald-950/20 mt-4\">\n              <h4 class=\"font-bold text-emerald-900 dark:text-emerald-200\">3. Folja \"lassen\" (lë)</h4>\n              <p class=\"text-sm text-emerald-800 dark:text-emerald-300\">\n                Përdoret kur veprimin <b>nuk e kryen vetë folësi, por dikush tjetër për të</b>:<br/>\n                &bull; <i>Ich kontrolliere mein Konto.</i> (Unë vetë e kontrolloj)<br/>\n                &bull; <i>Ich <b>lasse</b> mein Konto <b>kontrollieren</b>.</i> (E lë të kontrollohet nga bankieri/dikush tjetër)<br/>\n                Folja <i>lassen</i> zë pozitën e 2-të dhe folja tjetër shkon në infinitiv në fund pa 'zu'.<br/>\n                Me folje modale, <i>lassen</i> shkon në fund: <i>Ich muss meine Hausaufgaben <b>kontrollieren lassen</b>.</i> / <i>Frau Dume möchte sich nicht <b>operieren lassen</b>.</i>\n              </p>\n            </div>\n          </section>\n        ",
    "tables": [
      {
        "label": "Zgjedhimi i foljes 'lassen'",
        "headers": [
          "Njëjës",
          "Forma",
          "Shumës",
          "Forma"
        ],
        "rows": [
          [
            "Ich",
            "lasse",
            "Wir",
            "lassen"
          ],
          [
            "Du",
            "lässt",
            "Ihr",
            "lasst"
          ],
          [
            "Er / sie / es",
            "lässt",
            "Sie / sie",
            "lassen"
          ]
        ]
      }
    ],
    "examples": [
      {
        "ger": "Können Sie mir sagen, wie viel das kostet?",
        "alb": "A mund të më thoni ju mua, sa kushton kjo?"
      },
      {
        "ger": "Ich lasse mein Auto in der Werkstatt reparieren.",
        "alb": "Po e lë makinën të riparohet në servis (nga mekaniku)."
      }
    ],
    "exercises": [
      {
        "question": "Transformo në pyetje indirekte: 'Kommt Peter heute?'",
        "options": [
          "Weißt du, ob Peter heute kommt?",
          "Weißt du, wann Peter heute kommt?",
          "Weißt du, dass Peter heute kommt?"
        ],
        "correct": 0,
        "explanation": "Pyetjet 'Po/Jo' shndërrohen me lidhëzën 'ob' dhe me foljen në fund."
      },
      {
        "question": "Plotëso: Ich kann meine Haare nicht selbst schneiden. Ich ... sie schneiden.",
        "options": [
          "mache",
          "lasse",
          "gebe"
        ],
        "correct": 1,
        "explanation": "Përdoret 'lassen' kur shërbimin e bën dikush tjetër: 'Ich lasse sie schneiden'."
      }
    ]
  }
];
